import React, { useState, useEffect } from 'react';
import styles from './NetworkBanner.module.css';

export function useNetwork() {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [justReconnected, setJustReconnected] = useState(false);

    useEffect(() => {
        let timeoutId;

        const handleOnline = () => {
            setIsOnline(true);
            setJustReconnected(true);
            timeoutId = setTimeout(() => setJustReconnected(false), 3000);
        };
        const handleOffline = () => {
            setIsOnline(false);
            setJustReconnected(false);
            if (timeoutId) clearTimeout(timeoutId);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);

    return { isOnline, justReconnected };
}

export default function NetworkBanner() {
    const { isOnline, justReconnected } = useNetwork();

    if (isOnline && !justReconnected) return null;

    if (justReconnected) {
        return (
            <div className={`${styles.banner} ${styles.bannerOnline}`}>
                ✅ Sei di nuovo online!
            </div>
        );
    }

    return (
        <div className={`${styles.banner} ${styles.bannerOffline}`}>
            ⚠️ Nessuna connessione a Internet. Alcune funzioni potrebbero non essere disponibili.
        </div>
    );
}
